/**
 * Maps backend enums onto the CampaignOS <StatusPill> vocabulary
 * (running / scheduled / draft / completed / failed / approved / pending / risk).
 *
 * EmailMessageStatus (vendorhub-backend, campaign send pipeline) → pill + human label.
 */
export const MESSAGE_STATUS_PILL = {
  QUEUED: { pill: 'pending', label: 'Queued' },
  SENT: { pill: 'scheduled', label: 'Sent' },
  DELIVERED: { pill: 'approved', label: 'Delivered' },
  OPENED: { pill: 'approved', label: 'Opened' },
  CLICKED: { pill: 'completed', label: 'Clicked' },
  SOFT_BOUNCE: { pill: 'risk', label: 'Soft bounce' },
  HARD_BOUNCE: { pill: 'failed', label: 'Hard bounce' },
  SPAM: { pill: 'failed', label: 'Spam' },
  UNSUBSCRIBED: { pill: 'draft', label: 'Unsubscribed' },
  // A Mailtrap block counts as sent (operator decision, 23 Oct 2026).
  BLOCKED: { pill: 'scheduled', label: 'Sent' },
  FAILED: { pill: 'failed', label: 'Failed' },
};

export function messagePill(status) {
  return MESSAGE_STATUS_PILL[status] || { pill: 'draft', label: status };
}

/** Statuses the provider reports as bounced / rejected — these cannot be retried from our side. */
export const BOUNCE_STATUSES = new Set(['SOFT_BOUNCE', 'HARD_BOUNCE', 'SPAM']);

export function isBounceStatus(status) {
  return BOUNCE_STATUSES.has(status);
}

/** Vendor.status → pill + label (Audience table). */
export const VENDOR_STATUS_PILL = {
  ACTIVE: { pill: 'approved', label: 'Active' },
  PENDING: { pill: 'pending', label: 'Pending' },
  INACTIVE: { pill: 'draft', label: 'Inactive' },
  SUSPENDED: { pill: 'risk', label: 'Suspended' },
  REJECTED: { pill: 'failed', label: 'Rejected' },
};

export function vendorPill(status) {
  return VENDOR_STATUS_PILL[status] || { pill: 'draft', label: status };
}
